import { render, staticRenderFns } from "./imagePreview.vue?vue&type=template&id=1f96e552&scoped=true&"
import script from "./imagePreview.vue?vue&type=script&lang=ts&"
export * from "./imagePreview.vue?vue&type=script&lang=ts&"
import style0 from "./imagePreview.vue?vue&type=style&index=0&id=1f96e552&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f96e552",
  null
  
)

export default component.exports